import { CdkPortalOutlet, CdkPortalOutletAttachedRef, Portal, TemplatePortal } from '@angular/cdk/portal';
import { Component, ComponentRef, Input, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { SidebarService } from '@m4u-angular/core/framework/sidebar.service';
import { EnumSidebarActions, EnumSidebarStates, EnumWindowSizes } from '@m4u-angular/core/framework/sysenums.enum';
import { Subscription } from 'rxjs';

class State extends BaseState {
    //SidebarPinned: boolean;
    SidebarOpened: boolean;
}

export type SidebarPosition = 'left' | 'right';

@Component({
    providers: ServiceBagServices,
    selector: 'app-side-bar',
    templateUrl: './side-bar.component.html',
    styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent extends BaseComponent<State> {

    Name: string;
    //@Input() PageName: string;
    Title: string;
    ContentPortal: Portal<any>;
    SidebarState: EnumSidebarStates;
    SidebarComponentOptions?: any;
    SidebarPinned: boolean;
    Width: EnumWindowSizes;
    Position: SidebarPosition;
    Class: string;

    //@ViewChild('sidebarContent', {read: CdkPortalOutlet, static: false}) sidebarContent: CdkPortalOutlet;
    //@ViewChild('myTemplate') myTemplate: TemplateRef<any>;
    
    //@ViewChild('dynamicContainer', { read: ViewContainerRef }) containerRef: ViewContainerRef;
    //private _subscriptions: Subscription[] = [];
    get IsOpened() {
        return this.SidebarState === EnumSidebarStates.Opened;
    }

    get ShowPinButton() {
        return this.Name === 'Filters';
    }

    constructor(A: ServiceBagService, private sidebarService: SidebarService) {
        super(A, 'SideBarComponent', State);
    }

    //protected override OnInitComponent(): void {
    //    //this.sidebarService.Sidebar.subscribe(x => console.log(x));

    //    //this._subscriptions.push(this.A.SysEvents.Sidebar.subscribe(result => {
    //    //    if ((result.sidebarName === this.Name && result.pageComponentName === this.PageName) || result.force) this.SetSidebarState(result.action);
    //    //}));
    //}

    protected override OnInitComponentFinished(): void {
        //setTimeout(() => this.ContentPortal = new TemplatePortal(this.myTemplate, this.sidebarService.ViewContainerRef), 300);
        //if (this.sidebarContent && !this.sidebarContent.hasAttached()) {
        //    this.sidebarContent.attach(this.ContentPortal);
        //}
        
    }

    ContentAttached(ref: CdkPortalOutletAttachedRef) {
        if (this.SidebarComponentOptions && ref instanceof ComponentRef) {
            Object.entries(this.SidebarComponentOptions).forEach(([key, value]) => {
              ref.instance[key] = value;
            });
        }
    }

    GetWidthClass() {
        const width = this.Width || EnumWindowSizes.WindowSmall;
        switch (width) {
            case EnumWindowSizes.WindowXSmall: return 'p-sidebar-xs';
            case EnumWindowSizes.WindowSmall: return 'p-sidebar-s';
            case EnumWindowSizes.WindowMedium: return 'p-sidebar-m';
            case EnumWindowSizes.WindowLarge: return 'p-sidebar-l';
            case EnumWindowSizes.WindowXLarge: return 'p-sidebar-xl';
            case EnumWindowSizes.WindowAutoSize: return 'auto';
        }
    }

    GetPositionClass() {
        return this.Position || (this.A.Screen.IsRTL() ? 'left' : 'right')
    }

    PinSidebar() {
        this.SidebarPinned = !this.SidebarPinned;
    }

    CloseSidebar() {
        this.sidebarService.Close(this.Name);
    }

    OnSidebarViewChanged(state: 'show' | 'hide') {
        const sidebarState = state === 'show' ? EnumSidebarStates.Opened : EnumSidebarStates.Closed;
        this.sidebarService.OnStateChanged(this.Name, sidebarState);
    }

    protected override OnDestroyComponent(): void {
        //this.sidebarContent.detach();
    }
}
